// Central route -> Open Graph metadata resolver used by RouteOg at runtime.
// Data + builders live in ogStatic.js (shared with the build-time prerender).
import { ACCEPT_PAGES, CONVERT_PAGES, BUSINESS_PAGES, convertBySlug } from "./seoContent";
import { COUNTRY_PAGES } from "./countries";
import { OG_STATIC, ogAccept, ogConvert, ogBusiness, ogCountry } from "./ogStatic";

export function ogFor(pathname) {
  const p = pathname.replace(/\/+$/, "") || "/";
  if (OG_STATIC[p]) return OG_STATIC[p];

  let m = p.match(/^\/accept\/([a-z0-9-]+)$/);
  if (m) {
    const c = ACCEPT_PAGES.find((x) => x.slug === m[1]);
    if (c) return ogAccept(c);
  }
  m = p.match(/^\/convert\/([a-z0-9-]+)$/);
  if (m) {
    const c = convertBySlug(m[1]);
    if (c) return ogConvert(c, c.fiat);
  }
  m = p.match(/^\/accept-crypto-for\/([a-z0-9-]+)$/);
  if (m) {
    const c = BUSINESS_PAGES.find((x) => x.slug === m[1]);
    if (c) return ogBusiness(c);
  }
  m = p.match(/^\/accept-crypto-in\/([a-z0-9-]+)$/);
  if (m) {
    const c = COUNTRY_PAGES.find((x) => x.slug === m[1]);
    if (c) return ogCountry(c);
  }
  return null;
}
